import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import type TripPriceType from '../TripPriceType';
import type TrainPriceClass from './TrainPriceClass';
import { type SellType } from '@utils/train';

export default class TrainPriceType implements TripPriceType<TrainPriceClass> {
    /**
     * Creates an instance of TrainPriceType
     *
     * @memberof TrainPriceType
     */
    constructor(
        public sellType: SellType,
        public classes: TrainPriceClass[]
    ) {}

    /**
     * Returns the title of the train trip
     *
     * @type {string}
     * @memberof TrainPriceType
     */
    get title(): string {
        return this.sellType.title;
    }

    /**
     * Returns the description of train trip price
     *
     * @type {string}
     * @memberof TrainPriceType
     */
    get description(): string {
        return this.sellType.description;
    }

    get icon(): IconDefinition {
        return this.sellType.icon;
    }
}
